import { Segmented } from "antd";
import { ReactNode, useState } from "react";
import { GapLine, Wrapper } from "./atoms";

export function BlockTabs({
  items = [],
  showGapLine = true,
}: {
  items: {
    label: string | number;
    hidden?: boolean;
    children: ReactNode;
  }[];
  showGapLine?: boolean;
}) {
  const [activeKey, setActiveKey] = useState(items[0].label);
  return (
    <Wrapper>
      <Segmented
        options={items.filter((i) => !i.hidden).map((i) => i.label)}
        onChange={setActiveKey}
      />
      <GapLine showGapLine={showGapLine} />
      {
        items.filter((i) => !i.hidden).find((i) => i.label === activeKey)
          ?.children
      }
    </Wrapper>
  );
}
